import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { IDictionary } from '@core/common.model';

@Injectable({
  providedIn: 'root'
})
export class MinBookingLimitValidator {
  minBookingLimit(min: number, minBookingLimit: number): ValidatorFn {
    return (control: AbstractControl): IDictionary<{ message: string; min: number }> | null => {
      const value = control.value;
      if (!value) {
        return null;
      }

      if (value < minBookingLimit && value > min) {
        return {
          minBookingLimitError: { message: `Need minimum booking of ${minBookingLimit}`, min: minBookingLimit }
        };
      }

      return null;
    };
  }
}
